module.exports = __webpack_public_path__ + "static/img/beta_bg_01.4a847c1d.svg";